import {HttpMutators} from './http-mutators';
import {useHttp} from './http';

export const useOrganizationService = () => {
    const {get, post, patch, del} = useHttp('/organization');

    return {
        createOrganization: (mutators: HttpMutators, payload: any) => post(mutators, {payload}),
        getOrganizations: (mutators: HttpMutators) => get(mutators),
        getOrganization: (mutators: HttpMutators, id: string) => get(mutators, {url: `/${id}`}),
        getTosByOrg: (mutators: HttpMutators, id: string) => get(mutators, {url: `/${id}/tos`}),
        patchOrganization: (mutators: HttpMutators, id: string, payload: any) =>
            patch(mutators, {url: `/${id}`, payload}),
        postOrganizationToS: (mutators: HttpMutators, id: string, payload: any) =>
            post(mutators, {url: `/${id}/tos`, payload}),
        deleteOrganization: (mutators: HttpMutators, id: string) => del(mutators, {url: `/${id}`}),
    };
};
